import { inject } from '@angular/core';
import { ModulesService } from '../services/modules.service';

export function loadModules(): Promise<void> {
  return inject(ModulesService).load();
}
